import React from "react";

export type FunctionItemProps = {
  icon?: string
  onClick?: () => void
}

export const FunctionItem: React.FC<FunctionItemProps> = (props) => {
  const { icon, onClick } = props;

  return (
    <div
      className={'header-function-item rounded-full flex justify-center items-center text-lg bg-gray-300 cursor-pointer'}
      onClick={onClick}
    >
      <i className={icon}></i>
    </div>
  )
}
